import classNames from "classnames";
import PropTypes from "prop-types";
import styles from "./TableSortItem.module.css";
import chevron from "./down-arrow.png";
import { ChevronDown } from "react-ikonate";
/**
 * Clickable header to change table sort order. Toggles between asc and desc.
 */
export function TableSortItem({ value, title, onChange }) {
  return (
    <div className={classNames(styles.container)} onClick={onChange}>
      <div className={styles.text}>{title}</div>
      <div
        className={classNames(styles.arrow, value == "asc" ? styles.flip : "")}
      >
        <ChevronDown fontSize="22px"  />
      </div>
    </div>
  );
}

TableSortItem.propTypes = {
  value: PropTypes.string,
  title: PropTypes.string,
  onChange: PropTypes.func,
};
